import { render, staticRenderFns } from "./start-new-application-modal.vue?vue&type=template&id=2de0fc0a&scoped=true&"
import script from "./start-new-application-modal.vue?vue&type=script&lang=ts&"
export * from "./start-new-application-modal.vue?vue&type=script&lang=ts&"
import style0 from "./start-new-application-modal.vue?vue&type=style&index=0&id=2de0fc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0fc0a",
  null
  
)

export default component.exports